import { gql } from "@apollo/client";

const KEY_QUERY = gql`
  query credential($name: String!) {
    credential(name: $name) {
      id
      name
      credential_type
      properties
      properties_exist
      status
    }
  }
`;

const OAUTH_KEY_QUERY = gql`
  query credential_oauth($name: String!, $credential_type: String) {
    credential(name: $name, credential_type: $credential_type) {
      name
      exist
    }
  }
`;

const CREDENTIAL_LIST_QUERY = gql`
  query credentials(
    $first: Int
    $after: String
    $credentialTypes: [String!]
    $search: String
    $statusFilters: [String!]
    $sortBy: String
    $sortDirection: String
  ) {
    credentials(
      first: $first
      after: $after
      credentialTypes: $credentialTypes
      search: $search
      statusFilters: $statusFilters
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          name
          credential_type
          status
          properties
          description
        }
      }
    }
  }
`;

const GET_SUSPENDED_CREDENTIALS_COUNT = gql`
  query getSuspendedCredentialCount {
    getSuspendedCredentialCount
  }
`;

export { CREDENTIAL_LIST_QUERY, GET_SUSPENDED_CREDENTIALS_COUNT, KEY_QUERY, OAUTH_KEY_QUERY };
